import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const Vorlagen: React.FC = () => {
    const styles = useStyles();

    const handleOpenLink = () => {
        // Link to Sharepoint Online Templates area
        window.open('https://sharepoint.example.com/sites/vorlagen', '_blank');
    };

    return (
        <div className={styles.container}>
            <h1>Vorlagen</h1>
            <p>Verwaltung von Mailtexten und Word-Vorlagen in Sharepoint Online</p>
            <button onClick={handleOpenLink}>Zu Sharepoint - Vorlagen</button>
        </div>
    );
};

export default Vorlagen;
